// contract-editor/contract-editor-header.state.ts
import { Injectable, computed, signal } from '@angular/core';

type EditorObject = 'CONTRACT' | 'TEMPLATE'; 

/**
 * Bridges the routed ContractEditorComponent and the app-shell header.
 * The editor sets the context on init and MUST clear it on destroy.
 */
@Injectable({ providedIn: 'root' })
export class ContractEditorHeaderState {

  private readonly _name = signal<string | undefined>(undefined);
  private readonly _type = signal<EditorObject | undefined>(undefined);

  /** Title shown centered in the header (undefined = not on editor page) */
  readonly title = this._name.asReadonly();

  /** True while a contract editor page is active */
  readonly editorActive = computed(() => this._name() !== undefined);

  readonly editorType = computed(() => this._type());

  setContract(title: string): void {
    this._name.set(title);
    this._type.set('CONTRACT');
  }

  setTemplate(title: string): void {
    this._name.set(title);
    this._type.set('TEMPLATE');
  }

  clear(): void {
    this._name.set(undefined);
    this._type.set(undefined);
  }
}